import axios from "axios";
import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';

const TaskVeiwController = () => {
//   const getErrorMessage = (error) => {
//   return (
//     error.response?.data?.detail ||   // Django REST Framework style
//     error.response?.data?.message ||  // custom backend message
//     error.response?.data?.error ||    // another fallback
//     error.message ||                  // Axios default
//     "Something went wrong!"
//   );
// };
  const getTasks = (category, project, priority, status, showDeleted) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(`${BASE_URL}tasks/`, {
        params: {
          ...(category && { category }),
          ...(project && { project }),
          ...(priority && { priority }),
          ...(status && { status }),
          ...(showDeleted && { show_deleted: showDeleted }),
        },
      });
      dispatch({ type: "GET_TASKS_SUCCESS", payload: response.data });
    } catch (error) {
      dispatch({ type: "GET_TASKS_FAILURE", payload: { error } });
      //  const message = getErrorMessage(error);
    } finally {
      dispatch({ type: "LOADING", payload: false });
      // toast.error(message);
    }
  };
  
  

  const addTask = (reqData,category, project) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
  
    const authToken = localStorage.getItem('access_token');
    const axiosInstance = axios.create({
      baseURL: `${BASE_URL}`,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${authToken}`,
      },
    });
  
    try {
      const response = await axiosInstance.post('tasks/', reqData);
      const data = response.data;
      dispatch({ type: "ADD_TASK_SUCCESS", payload: data });
      await dispatch(getTasks(category, project));
      toast.success("Task added sucessfully");
    } catch (error) {
      dispatch({
        type: "ADD_TASK_FAILURE",
        payload: { error },
      });
      //  const message = getErrorMessage(error);
    } finally {
      dispatch({ type: "LOADING", payload: false });
      // toast.error(message);
    }
  };


  const updateTask = (id, reqData,category, project) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
  
    const authToken = localStorage.getItem('access_token');
  
    const axiosInstance = axios.create({
      baseURL: `${BASE_URL}`,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${authToken}`,
      },
    });
  
    try {
      const response = await axiosInstance.put(`tasks/${id}/`, reqData);
  
      const data = response.data;
      dispatch({ type: "UPDATE_TASK_SUCCESS", payload: data });
      await dispatch(getTasks(category, project));
      toast.success("Task updated sucessfully");
    } catch (error) {
      dispatch({
        type: "UPDATE_TASK_FAILURE",
        payload: { error },
      });
      //  const message = getErrorMessage(error);
    } finally {
      dispatch({ type: "LOADING", payload: false });
      // toast.error(message);
    }
  };

  const addTaskComment = (taskId, commentText, category, project) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    
    try {
      const response = await instance.post(`${BASE_URL}tasks/${taskId}/comments/`, {
        comment: commentText
      });
      
      // Update tasks list to fetch new comments
      await dispatch(getTasks(category, project));
      return response.data;
    } catch (error) {
      toast.error("Failed to post comment");
      console.error(error);
      throw error;
    } finally {
      dispatch({ type: "LOADING", payload: false });
    }
  };

  
  const deleteTask = (taskId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}tasks/${taskId}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_TASK_SUCCESS", payload: data });
      dispatch(getTasks());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Task dleted sucessfully");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      //  const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_TASK_FAILURE",
        payload: { error: error }
      });
      // toast.error(message);
    }
  };

  return {
    getTasks,
    addTask,
    updateTask,
    deleteTask,
    addTaskComment,
  };
};

export default TaskVeiwController;
